import { ReactNode, createContext, useContext } from "react";
import { useListCards } from "./list-cards.hook";

const ListCardsContext = createContext({} as ReturnType<typeof useListCards>);
export function useListCardsContext() {
  return useContext(ListCardsContext);
}

interface ListCardsProviderProps {
  children: ReactNode;
}
export function ListCardsProvider({ children }: ListCardsProviderProps) {
  return (
    <ListCardsContext.Provider value={useListCards()}>
      {children}
    </ListCardsContext.Provider>
  );
}
